// frontend/src/components/auth/LanguageSelector.tsx
/**
 * 🧠 Pensado por Alcélio Gomes - Codificado com Claude Code
 * 🚀 NeuroAgentes Platform - Intelligent Agent Development
 *
 * Seletor de idioma das telas de autenticação.
 *
 * EXTRAÍDO de LoginPage.tsx em 30/08/2026. É componente reutilizável, e estava
 * declarado dentro da página — o que impedia qualquer outra tela de usá-lo.
 */

import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import {
  VERDE_MENTA,
  FUNDO_PAPEL,
  TEXTO_PRIMARIO,
  withAlpha
} from '../../themes/themeConstants';

export interface LanguageSelectorProps {
  currentLang: string;
  onChangeLang: (lang: string) => void;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ currentLang, onChangeLang }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleLangChange = (lang: string) => {
    onChangeLang(lang);
    handleClose();
  };
  
  // Mapeamento de idiomas para exibição
  const languages = {
    pt: "Português",
    en: "English"
  };
  
  return (
    <Box sx={{ position: 'absolute', top: 20, right: 20 }}>
      <Tooltip title="Selecionar idioma">
        <IconButton
          onClick={handleClick}
          size="medium"
          sx={{ 
            color: VERDE_MENTA,
            background: withAlpha(VERDE_MENTA, 0.1),
            '&:hover': {
              background: withAlpha(VERDE_MENTA, 0.2),
            }
          }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
        PaperProps={{
          sx: {
            mt: 1.5,
            backgroundColor: FUNDO_PAPEL,
            borderRadius: 2,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            border: `1px solid ${withAlpha(VERDE_MENTA, 0.2)}`,
          }
        }}
      >
        {Object.entries(languages).map(([code, name]) => (
          <MenuItem 
            key={code} 
            onClick={() => handleLangChange(code)}
            selected={currentLang === code}
            sx={{
              fontWeight: currentLang === code ? 600 : 400,
              px: 2,
              py: 1,
              minWidth: 120,
              color: currentLang === code ? VERDE_MENTA : TEXTO_PRIMARIO,
              '&.Mui-selected': {
                backgroundColor: withAlpha(VERDE_MENTA, 0.15),
              },
              '&:hover': {
                backgroundColor: withAlpha(VERDE_MENTA, 0.1),
              }
            }}
          >
            {name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
